import GridRowLabel from 'components/Grid/GridRowLabel';
import { GrossIRRColumnDefinition } from './types';

const grossIRRFormat = {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  isDecimal: true,
  validateFloat: true,
};

export const GROSS_IRR_COLUMN_CONFIG = {
  valueViewer: (props: any) => <GridRowLabel {...props} />,
  className: 'table-header division-bottom-only text-right'
};

export const getGrossIRRColumns = (): GrossIRRColumnDefinition[] => [
  {
    alias: 'fund_name',
    value: 'Fund',
    gridType: 'string',
    dbType: 'string',
    readOnly: true,
  },
  {
    alias: 'gross_irr',
    value: 'Gross IRR',
    gridType: 'percentage',
    dbType: 'number',
    format: grossIRRFormat,
    readOnly: true,
    className: 'text-align-right',
  },
];
